import { ApolloLink } from '@apollo/client'

const DATOCMS_KEY = process.env.NEXT_PUBLIC_DATOCMS_KEY!

export function createAuthLink(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    const prevHeaders = operation.getContext().headers || {}

    operation.setContext({
      headers: {
        ...prevHeaders,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${DATOCMS_KEY}`,
      },
    })

    return forward(operation)
  })
}
